// chakra imports
import { Box, Flex, Stack } from "@chakra-ui/react";
//   Custom components
import Brand from "components/sidebar/components/Brand";
import Links from "components/sidebar/components/Links";
import SidebarCard from "components/sidebar/components/SidebarCard";
import React from "react";

// FUNCTIONS

function SidebarContent(props) {
  const { routes, onClose } = props;

  // SIDEBAR
  return (
    <Flex direction="column" pt="10px">
      <Brand />
      <Stack direction="column" mb="auto" mt="15px" p={0} spacing={2}>
        <Flex
          direction={"column"}
          px="16px"
          py="10px"
          position="relative"
          zIndex="1"
        >
          <Box
            mb="15px"
            opacity="0.6"
            fontSize="xs"
            fontWeight="bold"
            textTransform="uppercase"
            letterSpacing="wider"
            color="gray.500"
            pl="10px"
          >
            Main Menu
          </Box>
          <Links routes={routes} onClose={onClose} />
        </Flex>
      </Stack>

      <Box mt="60px" mb="40px" mx="10px" borderRadius="10px">
        <SidebarCard />
      </Box>
    </Flex>
  );
}

export default SidebarContent;
